<div class="registration-container">
    <form [formGroup]="leaveForm" (ngSubmit)="submitLeave()" class="form-container">

        <!-- ===================== COMPANY INFORMATION ===================== -->
        <h2 class="section-title">Apply Leave</h2>
      <div class="form-section grid-2">
  <mat-form-field appearance="outline">
    <mat-label>Employee Number</mat-label>
    <input matInput [value]="empNo" readonly />
  </mat-form-field>

  <div class="leave-type-wrapper">
   <mat-form-field appearance="outline" class="leave-type">
  <mat-label>Leave Type</mat-label>
  <mat-select
    formControlName="leave_category_id"
    (selectionChange)="onLeaveTypeChange($event)"
    required
  >
    <mat-option *ngFor="let c of leaveCategories$ | async" [value]="c.id">
      {{ c.name }}
    </mat-option>
  </mat-select>
</mat-form-field>

<!-- Available Leave shown below -->
<div class="available-leave" *ngIf="availableLeave > -1">
  Available: {{ availableLeave | number:'1.2-2' }}
</div>

  </div>
 
           

            
</div>
<div class="form-section grid-1">
  <div class="file-upload" *ngIf="medicalLeave">
        <label>Medical Certificate*</label>
        <div class="upload-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="medicalInput.click()">
            <mat-icon>upload_file</mat-icon> Choose File
          </button>
          <span class="file-name">{{ medicalCertificateFileName || 'No file chosen' }}</span>
          <input #medicalInput type="file" (change)="onFileChange($event)" hidden />
        </div>
      </div>
</div>
        <div class="form-section grid-2">
            <mat-form-field appearance="outline">
                <mat-label>From Date</mat-label>
                <input matInput [matDatepicker]="fromPicker" formControlName="start_date" required>
                <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
                <mat-error *ngIf="leaveForm.get('start_date')?.hasError('required')">
                    Start Date is required
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>To Date</mat-label>
                <input matInput [matDatepicker]="toPicker" formControlName="end_date" required>
                <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                <mat-datepicker #toPicker></mat-datepicker>
                <mat-error *ngIf="leaveForm.get('end_date')?.hasError('required')">
                    End Date is required
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-section grid-2">
            <mat-form-field appearance="outline" class="reason-field">
                <mat-label>Reason</mat-label>
                <textarea style="height: 100px !important;" matInput formControlName="reason" rows="3" required></textarea>
            </mat-form-field>
        </div>
        <div class="form-actions">
            <button mat-raised-button color="primary" type="submit" class="submit-vendor-btn">
                <span *ngIf="!isLoading">Apply Leave</span>
                <span *ngIf="isLoading" class="loader"></span>
            </button>
        </div>
    </form>
</div>